var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"set_product_type"},_vm._l((_vm.typeList),function(ref){
var _obj;

var prefix = ref.prefix;
var name = ref.name;
var type = ref.type;
var feature = ref.feature;
var slatWidth = ref.slatWidth;
var shield = ref.shield;
var weight_bar = ref.weight_bar;
var display = ref.display;
var itemList = ref.default;
var subName = ref.subName;return _c('button',{key:type,staticClass:"product_type__btn",class:( _obj = {
      long: name.length > 10,
      picked: _vm.isPicked(type),
      column: subName
    }, _obj[("prefix-" + prefix)] = true, _obj ),attrs:{"type":"button","disabled":_vm.isPicked(type)},on:{"click":function($event){$event.stopPropagation();return _vm.updateProductType(prefix, type, feature, slatWidth, shield, weight_bar, display, itemList, $event)}}},[_vm._v(_vm._s(name)),(subName)?_c('span',[_vm._v("("+_vm._s(subName)+")")]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }